import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoEyeOutline } from "react-icons/io5";
import { FaRegEyeSlash } from "react-icons/fa";
import { BaseUrl } from "../api";
import { toast } from "react-toastify";

const Signup = () => {
  const [visible, setVisible] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState({
    username: "",
    email: "",
    password1: "",
    password2: "",
  });
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("username", username);
      formData.append("password1", password1);
      formData.append("password2", password2);
      fetch(`${BaseUrl}/register/`, {
        method: "POST",
        body: formData,
      }).then((response) => {
        if (response.ok) {
          navigate("/");
          window.location.reload();
        } else {
          response.json().then((data) => {
            setError({
              username: data?.username,
              email: data?.email,
              password1: data?.password1,
              password2: data?.password2,
            });
          });
          console.log(error);
        }
      });
    } catch (error: any) {
      toast.error("error: ", error);
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-start bg-[#f7f7f7]  flex-col  py-12 sm:px-6 lg:px-8">
      <div>
        {/* <Image src={darkomImage} alt="image" className="w-[200px]" /> */}
      </div>
      <div className="sm:mx-auto sm:w-full sm:max-w-md mt-16">
        <h2 className="text-center text-3xl font-extrabold text-gray-900">
          Signup Student
        </h2>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-xl sm:rounded-lg sm:px-10">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Email Address
              </label>
              <div className="mt-1">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>
              <p className="text-red-500 mt-5">
                {error.email ? error.email : ""}
              </p>
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                User Name
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>
              <p className="text-red-500 mt-5">
                {error.username ? error.username : ""}
              </p>
            </div>

            <div>
              <label
                htmlFor="password1"
                className="block text-sm font-medium text-gray-700"
              >
                Password
              </label>
              <div className="mt-1 relative">
                <input
                  type={visible ? "text" : "password1"}
                  name="password1"
                  autoComplete="current-password1"
                  required
                  value={password1}
                  onChange={(e) => setPassword1(e.target.value)}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
                {visible ? (
                  <IoEyeOutline
                    className="absolute right-2 top-2 cursor-pointer"
                    size={25}
                    onClick={() => setVisible(false)}
                  />
                ) : (
                  <FaRegEyeSlash
                    className="absolute right-2 top-2 cursor-pointer"
                    size={25}
                    onClick={() => setVisible(true)}
                  />
                )}
              </div>

              <p className="text-red-500 mt-5">
                {error.password1 ? error.password1 : ""}
              </p>
              <label
                htmlFor="password1"
                className="block text-sm font-medium text-gray-700 mt-7"
              >
                Confirm Password
              </label>
              <div className="mt-1 relative">
                <input
                  type={visible ? "text" : "password2"}
                  name="password2"
                  autoComplete="current-password2"
                  required
                  value={password2}
                  onChange={(e) => setPassword2(e.target.value)}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
                {visible ? (
                  <IoEyeOutline
                    className="absolute right-2 top-2 cursor-pointer"
                    size={25}
                    onClick={() => setVisible(false)}
                  />
                ) : (
                  <FaRegEyeSlash
                    className="absolute right-2 top-2 cursor-pointer"
                    size={25}
                    onClick={() => setVisible(true)}
                  />
                )}
              </div>

              <p className="text-red-500 mt-5">
                {error.password2 ? error.password2 : ""}
              </p>
            </div>
            <div>
              <button
                type="submit"
                // disabled={loading}
                className={`group relative w-full h-[40px] flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white ${
                  false ? "bg-gray-500" : "bg-blue-600 hover:bg-blue-700"
                }`}
              >
                {false ? "Loading..." : "Sign up"}
              </button>
              {false && (
                <p className="mt-2 text-sm text-red-600 text-center">
                  {"error"}
                </p>
              )}
            </div>
            <div>
              <h4>already have an account?</h4>
              <Link to="/login" className="text-blue-600">
                Login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Signup;
